import PrimeVue from 'primevue/config';
import BT from "./bt/BT.vue";
import {createApp} from "vue";
import Aura from '@primeuix/themes/aura';
import ConfirmationService from 'primevue/confirmationservice';
import {createI18n} from 'vue-i18n'
import {messages} from './i18n';
import BTOneRow from "@/bt/BTOneRow.vue";

const i18n = createI18n({
  legacy: false,
  locale: document.documentElement.getAttribute('lang') as string,
  messages,
})

let component = BT;
if (document.querySelector('article')?.classList.contains('node--type-nwrm')) {
  component = BTOneRow;
}

createApp(component)
  .use(PrimeVue, {
    theme: {
      preset: Aura
    }
  })
  .use(i18n)
  .use(ConfirmationService)
  .mount("#vue-bt");
